import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedProducts from './components/FeaturedProducts';
import CollectionsBanner from './components/CollectionsBanner';
import WhyUs from './components/WhyUs';
import Testimonials from './components/Testimonials';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <FeaturedProducts />
      <CollectionsBanner />
      <WhyUs />
      <Testimonials />
      <Footer />
    </main>
  );
}
